import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const sqReportApi = createApi({
  baseQuery,
  reducerPath: 'sqReportApi',
  endpoints: builder => ({
    getReportData: builder.query<any, any>({
      query: ({ monitoring_visit_id, site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.Report.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?monitoring_visit_id=${monitoring_visit_id}&country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getsqReportData: builder.query<any, any>({
      query: ({ monitoring_visit_id, site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.Report.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?monitoring_visit_id=${monitoring_visit_id}&country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createReport: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Report.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateReport: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Report.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getSiteStudyPersonnels: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.SiteStudyPersonnel.personnelSelect,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&site_contact_info=true`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getAllSQReports: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.Report.getAll
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    publishSQReportEtmf: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        publish_doc_version,
        is_published,
        monitoring_visit_id,
        update,
        application,
        application_section
      }) => ({
        url: `${formatString(
          endPoints.Report.pulishEtmf,
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.site_id, value: site_id }
        )}?country=${country}&publish_doc_version=${publish_doc_version}&monitoring_visit_id=${monitoring_visit_id}&is_published=${is_published}&update=${update}&application=${application}&application_section=${application_section}`,
        method: 'POST',
        body: {}
      })
    })
  })
});

export const {
  useGetReportDataQuery,
  useCreateReportMutation,
  useUpdateReportMutation,
  useGetSiteStudyPersonnelsQuery,
  useLazyGetsqReportDataQuery,
  useGetAllSQReportsMutation,
  usePublishSQReportEtmfMutation
} = sqReportApi;
